import { ContextType, useContext } from "react";

import { LocalStoreContext } from "../contexts/localStore";

export function useLocalStore(): ContextType<typeof LocalStoreContext> {
  return useContext(LocalStoreContext);
}
